// Данные легенды апвеллинга. Вынесены из вёрстки, чтобы проверять главное:
// легенда описывает ИМЕННО ТО, что нарисовано на карте, и не заводит своей
// копии цветов и глубин.

import { ISOBATH_DEPTHS, ISOBATH_STYLES, isobathLabel, type IsobathStyle } from '../map/isobaths'

/** Порог прозрачности рендера: `src/tiles/upwelling_tiles.py::_LOW_INDEX`.
 *  Ниже него пиксель не красится вовсе — легенда обязана про это сказать,
 *  иначе пустая вода читается как «данных нет». */
export const LOW_INDEX_CUTOFF = 0.05

/** Подписи шкалы — как у colorbar телеграм-карты (`_draw_colorbar`). */
export const HEAT_TICKS = [
  { value: 0, labelKey: 'models.upwelling.low' },
  { value: 0.5, labelKey: 'models.upwelling.medium' },
  { value: 1, labelKey: 'models.upwelling.high' },
] as const

export interface LegendIsobathRow {
  depth: number
  label: string
  color: string
  width: number
  /** `stroke-dasharray` для SVG-образца; `undefined` — сплошная. */
  dash: string | undefined
}

/** Увеличение образца. Линия 0.8 px в двухпиксельной плашке легенды неразличима,
 *  поэтому образцы рисуем крупнее карты — НО одним множителем на толщину и на
 *  штрихи, иначе пунктир 50 м перестал бы быть похож на себя. */
export const SAMPLE_SCALE = 1.8

/** Штриховка MapLibre (в толщинах линии) → SVG (в пикселях). */
export function legendDashArray(style: IsobathStyle, scale = 1): string | undefined {
  if (!style.dash) return undefined
  return style.dash.map(d => +(d * style.width * scale).toFixed(2)).join(' ')
}

export function isobathLegendRows(scale = 1): LegendIsobathRow[] {
  return ISOBATH_DEPTHS.map(depth => {
    const style = ISOBATH_STYLES[depth]
    return {
      depth,
      label: isobathLabel(depth),
      color: style.color,
      width: style.width * scale,
      dash: legendDashArray(style, scale),
    }
  })
}
